export default {
  PROCESS: "process",
  DONT_PROCESS: "dont_process",
  DECLINE: "decline",
  ATTACHMENT_TO_AGENCY: "attachment_to_agency",
};
